// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2IIdX","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Tccu"};